/**
 * Promise wrapper for XMLHttpRequest upload
 * @param file
 * @param url
 * @param listeners event listeners: onLoadStart, onLoad, onLoadEnd, onProgress, onError, onAbort
 * @returns http status code, 200 if ok
 */
export function uploadXHR(
  file: File,
  url: string,
  listeners?: {
    onLoadStart?: (this: XMLHttpRequest, e?: ProgressEvent<XMLHttpRequestEventTarget>) => void;
    onLoad?: (this: XMLHttpRequest, e?: ProgressEvent<XMLHttpRequestEventTarget>) => void;
    onLoadEnd?: (this: XMLHttpRequest, e?: ProgressEvent<XMLHttpRequestEventTarget>) => void;
    onProgress?: (this: XMLHttpRequest, e?: ProgressEvent<XMLHttpRequestEventTarget>) => void;
    onError?: (this: XMLHttpRequest, e?: ProgressEvent<XMLHttpRequestEventTarget>) => void;
    onAbort?: (this: XMLHttpRequest, e?: ProgressEvent<XMLHttpRequestEventTarget>) => void;
  },
  headers?: Record<string, string>,
): Promise<number> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);
    if (headers) {
      for (const [key, value] of Object.entries(headers)) {
        xhr.setRequestHeader(key, value);
      }
    }
    xhr.onreadystatechange = function (this: XMLHttpRequest, e) {
      // readyState 4 means the request is done
      if (this.readyState === 4) {
        resolve(this.status);
      }
    };
    xhr.onerror = function (this: XMLHttpRequest, e) {
      console.error('XHR upload error: event=', e);
      console.error('XHR upload error: status=', this.status, 'response=', this.response);
      reject(new Error(`XHR upload error: ${this.status} ${this.response}`));
    };
    if (listeners?.onLoadStart) {
      xhr.addEventListener('loadstart', listeners.onLoadStart);
    }
    if (listeners?.onLoad) {
      xhr.addEventListener('load', listeners.onLoad);
    }
    if (listeners?.onLoadEnd) {
      xhr.addEventListener('loadend', listeners.onLoadEnd);
    }
    if (listeners?.onProgress) {
      xhr.addEventListener('progress', listeners.onProgress);
    }
    if (listeners?.onError) {
      xhr.addEventListener('error', listeners.onError);
    }
    if (listeners?.onAbort) {
      xhr.addEventListener('abort', listeners.onAbort);
    }
    xhr.send(file);
  });
}
